import * as Yup from 'yup'

export default Yup.object().shape({
  // mail: Yup.string().required('login.mail.required').email(),
  password: Yup.string().required('login.password.required').min(4).max(25)
})
